import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import AnimatedSection from "./AnimatedSection";
import PointedSectionBackground from "./PointedSectionBackground";

const AboutSection = () => {
  return (
    <section id="about" className="homepage-about relative z-10 pt-20 pb-10 md:pb-14">
      <PointedSectionBackground bodyClassName="homepage-about-body" />

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <AnimatedSection className="max-w-3xl mx-auto text-center">
          <span className="section-label">Who We Are</span>
          <h2 className="section-title mb-8">Rogue Skull Games</h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed mb-10">
            RSG is a new indie board game publisher founded in Kansas, with a passion for exciting, strategic tabletop
            experiences with a tendency for rogue-like sabotage among friends & enemies.
          </p>
          <Link to="/about" className="btn-outline-light group">
            Learn more about RSG
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default AboutSection;
